/* eslint-disable no-undefined */
// Copyright (c) 2023 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {
    getPinPlateRecord
} from '../../../product/shared/repositories';
import {routerActions} from 'react-router-redux';

export const readPinPlateRequest = id =>

    async dispatch => {

        let route;

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const pinPlate = await getPinPlateRecord(id);

            if (pinPlate === '') {

                route = '/';

                dispatch(routerActions.push(route));

            } else {

                pinPlate.dateSubmmited = pinPlate.dateSubmmited === null ? Date.now() : pinPlate.dateSubmmited;

                dispatch({
                    data: pinPlate,
                    type: actions.UPDATE_PIN_PLATE_REQUEST
                });

            }

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/duplicate-pin-plate/action-creators/get-duplicate-pin-plate-request.js